// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ShareIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from share.svg
 */
export default function ShareIcon(props: ShareIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ShareIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M8.707.293 8.613.21 8.51.14a1 1 0 0 0-1.218.153l-4 4-.083.094a1 1 0 0 0 .083 1.32l.094.083a1 1 0 0 0 1.32-.083L7 3.415V11l.007.117A1 1 0 0 0 9 11V3.415l2.293 2.292.094.083a1 1 0 0 0 1.32-1.497zm7.286 9.59A1 1 0 0 0 15 9l-.117.007A1 1 0 0 0 14 10v4H2v-4l-.007-.117A1 1 0 0 0 0 10v5l.007.117A1 1 0 0 0 1 16h14l.117-.007A1 1 0 0 0 16 15v-5z"
        />
      </g>
    </svg>
  );
}
